export default __webpack_public_path__ + "static/kyc-aml-resource-banner-3-0b6c4dd78f9c3b06565d00c305298302.png";